import { relaunchApi } from '@/logic/relaunchApi'

export default {
  setOnlineStatus: (sessionId) => relaunchApi.postAndForget('/account/online', { sessionId }),
  setOfflineStatus: (sessionId) => relaunchApi.postAndForget('/account/offline', { sessionId }),
}
